import { call, put, select, takeEvery } from 'redux-saga/effects';
import isUndefined from 'lodash/isUndefined';

import { getUnleashInstance } from '../../../libs/unleash';
import {
  getUnleashFlagMasksFromSessionStorage,
  setUnleashFeatureFlag,
} from '../../../utils/featureFlags';
import isUnleashFeatureEnabled from '../../../selectors/isUnleashFeatureEnabled';
import { loadFeatureFlagsSuccess, loadFeatureFlagsFailure } from './actions';
import {
  UNLEASH_FEATURE_FLAGS_LOAD,
  UNLEASH_FEATURE_FLAG_TOGGLE,
} from './types';

/**
 * Persists the value of feature flag to session storage.
 *
 * This is an example of saga handling pure side effects.
 *
 * @param {Object} action `UNLEASH_FEATURE_FLAG_TOGGLE` action
 */
function* featureFlagToggleSaga(action) {
  const { id } = action.payload;

  // Saga happens after reducer, so we are getting the updated value here
  const isEnabled = yield select(isUnleashFeatureEnabled, id);

  // Persist the flag
  yield call(setUnleashFeatureFlag, id, isEnabled);
}

function* featureFlagLoadSaga(action) {
  try {
    const { businessId } = action.payload;

    const unleash = yield getUnleashInstance(businessId);

    const masks = getUnleashFlagMasksFromSessionStorage();
    const flags = unleash.getAllToggles().map((toggle) => {
      return {
        id: toggle.name,
        isEnabled: toggle.enabled,
        variant: toggle.variant,
      };
    });

    const maskedFlags = flags.map((flag) => {
      // Then override with sessionStorage mask
      if (!isUndefined(masks[flag.id])) {
        const mask = masks[flag.id];
        flag.isEnabled = mask;
        flag.variant.enabled = mask;
      }

      return flag;
    });

    yield put(loadFeatureFlagsSuccess(maskedFlags));
  } catch (error) {
    yield put(loadFeatureFlagsFailure(error));
  }
}

export default function* saga() {
  yield takeEvery(UNLEASH_FEATURE_FLAG_TOGGLE, featureFlagToggleSaga);
  yield takeEvery(UNLEASH_FEATURE_FLAGS_LOAD, featureFlagLoadSaga);
}
